import { useQuery } from '@tanstack/react-query';
import { pb, TutorProfile } from '@/lib/pocketbase';

export const useFeaturedTutors = () => {
  const query = useQuery({
    queryKey: ['featured-tutors'],
    queryFn: async () => {
      try {
        // Only fetch featured tutors
        const tutors = await pb.collection('tutors').getList(1, 4, {
          expand: 'user',
          sort: '-created',
          filter: 'isFeatured = true && profilePicture != ""'
        });
        
        return tutors.items as TutorProfile[];
      } catch (error: any) {
        if (error.status !== 0 && error.status !== 403 && error.status !== 401) {
          console.error('Error fetching featured tutors:', error);
        }
        // Fallback to public access
        try {
          const publicTutors = await pb.collection('tutors').getList(1, 4, {
            sort: '-created',
            filter: 'isFeatured = true && profilePicture != ""',
            requestKey: null,
          });
          return publicTutors.items as TutorProfile[];
        } catch (publicError) {
          return [];
        }
      }
    },
    refetchOnWindowFocus: false,
    staleTime: 60000, // Cache for 1 minute
  });

  return {
    featuredTutors: query.data || [],
    isLoading: query.isLoading,
    error: query.error,
  };
};
